import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
function NewUnemployed() {
    const ID = Cookies.get("log_id");
    const [candidates,setCandidates] = useState([]);
    const [selectedCandidate,setSelectedCandidate] = useState(false);
    const [candidate,setCandidate] = useState(false);
    const [status,setStatus] = useState("");
    const [reason,setReason] = useState("");
    function FetchNew() {
        axios.get(`${url.path}/new_unemployed_candidates/`)
        .then((res) =>{
            if(res.data.status){
                var unemp = res.data.unemployed;
                setCandidates([])
                unemp.map((i)=>{
                    setCandidates((prevState) =>[
                        ...prevState, i
                    ])
                })
            }
        }).catch((err)=>{
          Toast.fire({
            icon:'error',
            title:err
          })
          })

    }
    useEffect(() =>{
        FetchNew();
      },[])
        const itemsPerPage = 3;
            const [searchTerm, setSearchTerm] = useState("");
            const [currentPage, setCurrentPage] = useState(0);
      
            const filteredData = candidates.filter((item) =>
              item.Candidate_Name.toLowerCase().includes(searchTerm.toLowerCase())
            );
      
            const offset = currentPage * itemsPerPage;
            const currentItems = filteredData.slice(offset, offset + itemsPerPage);
            const pageCount = Math.ceil(filteredData.length / itemsPerPage);
      
            const handlePageClick = ({ selected }) => {
              setCurrentPage(selected);
            };
            function searchTable(){
              var rows = document.querySelectorAll('#unemptable tbody tr');
              var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
              rows.forEach(function(row) {
                var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
                row.style.display = text.includes(val) ? '' : 'none';
              });
            }

            const handleOpenModal = (cmp) => {
                setSelectedCandidate(cmp);
              };
              const handleCloseModal = () => {
                setSelectedCandidate(null);
              };
              const handleModal = (cmp) =>{
                setCandidate(cmp);
              };
              const closeModal = () =>{
                setCandidate(null);
              };

        const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
              },
            });
      function Approve(e) {
        e.preventDefault();
        const formdata = new FormData();
        formdata.append('id',ID);
        formdata.append('unemployed',selectedCandidate.id);
        formdata.append('status',status);
        formdata.append('reason',reason);
        axios.post(`${url.path}/unemp_decision/`,formdata)
        .then((res) =>{
          if (res.data.status){
            Toast.fire({
              icon:'success',
              title:'Approved'
            })
            FetchNew();
          }
        }).catch((err)=>{
          Toast.fire({
            icon:'error',
            title:err
          })
        })
      }
      function DisApprove(e) {
        e.preventDefault();
        const formdata = new FormData();
        formdata.append('id',ID);
        formdata.append('unemployed',candidate.id);
        formdata.append('status',status);
        formdata.append('reason',reason);
        axios.post(`${url.path}/unemp_decision/`,formdata)
        .then((res) =>{
          if (res.data.status){
            Toast.fire({
              icon:'warning',
              title:'DisApproved..'
            })
            FetchNew();
          }
        }).catch((err)=>{
          Toast.fire({
            icon:'error',
            title:err
          })
        })
      }
    return(
        <>
        <Navbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>New UnEmployed</h3>
            </center>
            <div className="search-container">
    <input
      type="text"
      placeholder="Search..."
      onKeyUp={searchTable}
      className="search-input"
      id="search"
    />
  </div>
        <div className="table-container">
      <table className="responsive-table" id="unemptable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Name</th>
            <th>Email</th>
            <th>Contact</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {candidates.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.Candidate_Name}</td>
              <td>{i.Email}</td>
              <td>{i.Contact}</td>
                <td><button type="button" style={{width:'80px',backgroundColor:'green',color:'white',borderRadius:'5px'}} onClick={() => handleOpenModal(i)}>Approve</button>
                <button type="button" style={{width:'100px',backgroundColor:'red',color:'white',borderRadius:'5px',marginLeft:'5px'}} onClick={() => handleModal(i)}>Disapprove</button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
    {selectedCandidate && (
    <div className="modal-overlay" onClick={handleCloseModal}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="close-button"
          onClick={handleCloseModal}
        >
          &times;
        </button>
        <h2>Approve Candidate</h2>
        <p>Are you sure to Approve {selectedCandidate.Candidate_Name}</p>
        <form onSubmit={Approve}>
          <center>
          <button type="submit" style={{width:'100px',backgroundColor:'gainsboro',borderRadius:'5px'}} onClick={() =>setStatus("Approved")}>Approve</button>
          </center>
        </form>
      </div>
    </div>
  )}
  {candidate && (
    <div className="modal-overlay" onClick={closeModal}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="close-button"
          onClick={closeModal}
        >
          &times;
        </button>
        <h2>Disapprove Candidate</h2>
        <p>Are you sure to Disapprove {candidate.Candidate_Name}</p>
        <form onSubmit={DisApprove}>
        <div className="form-group-row">
              <div className="form-group">
                <label style={{fontSize:'15px'}}>Rejection Reason</label>
                <input type="text" id="reasoninput" onChange={(e) =>setReason(e.target.value)} />
              </div>
            </div>
          <center>
          <button type="submit" style={{width:'100px',backgroundColor:'gainsboro',borderRadius:'5px'}} onClick={() =>setStatus("Rejected")}>Disapprove</button>
          </center>
        </form>
      </div>
    </div>
  )}
        </>
    );
}
export default NewUnemployed;